import { render } from "./BboxBlurLabelSelect.vue?vue&type=template&id=64df3d30&scoped=true"
import script from "./BboxBlurLabelSelect.vue?vue&type=script&lang=js"
export * from "./BboxBlurLabelSelect.vue?vue&type=script&lang=js"

import "./BboxBlurLabelSelect.vue?vue&type=style&index=0&id=64df3d30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64df3d30"]])

export default __exports__